import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyAvatarComponent } from './formly-avatar.component';

@NgModule({
  imports: [
    FormlyAvatarComponent,
    FormlyModule.forChild({
      types: [
        { name: 'avatar', component: FormlyAvatarComponent },
      ],
    }),
  ],
})
export class FormlyAvatarModule {}
